import React from 'react';
import type { ReactNode } from 'react';

import LinkButton from '@atlaskit/button/link';
import type { NewCoreIconProps } from '@atlaskit/icon/types';
import PersonAvatarIcon from '@atlaskit/icon/core/person-avatar';

import { fg } from '@confluence/feature-gating';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { useNavigateToTeamsApp } from '@confluence/teams-app-config/entry-points/useNavigateToTeamsApp.ts';

type HTV2ActionCardLinkCTAProps = {
	onClick: () => void;
	href: string;
	children: ReactNode;
	icon: React.ComponentType<NewCoreIconProps>;
};
type CTAComponentProps = Omit<HTV2ActionCardLinkCTAProps, 'href' | 'icon'>;

const HTV2ActionCardLinkCTA = ({ onClick, href, children, icon }: HTV2ActionCardLinkCTAProps) => {
	return (
		<LinkButton iconBefore={icon} onClick={onClick} href={href} target="_blank">
			{children}
		</LinkButton>
	);
};

export const HTV2AddProfilePictureCTA = ({
	children,
	onClick,
}: CTAComponentProps): React.JSX.Element => {
	const { userId } = useSessionData();
	const { href } = useNavigateToTeamsApp({
		type: 'USER',
		payload: {
			userId: userId ?? '',
		},
	});
	return (
		<HTV2ActionCardLinkCTA
			icon={PersonAvatarIcon}
			onClick={onClick}
			href={fg('confluence-adopt-teams-nav-config') ? href : `/wiki/people/${userId}`}
		>
			{children}
		</HTV2ActionCardLinkCTA>
	);
};
